import React from 'react';

export default function NotFound() {
  return <h1>404 - Página não encontrada</h1>;
}
